import ClassNames from "classnames";
import { FunctionComponent } from "react";
import styles from "../stylesheets/components/header-action-links.module.css";
import { Accommodation, ActionLinks, Language } from "../types/index.js";
import { getActionAndContactLinks } from "../utils/utils.js";
import Icon from "./Icon.js";
import SmartLink from "./SmartLink.js";

interface Props {
  isPreview: boolean;
  actionLinks: ActionLinks;
  accommodation: Accommodation | undefined;
  languageId: Language;
  className?: string;
}

const HeaderActionLinks: FunctionComponent<Props> = ({
  isPreview,
  actionLinks,
  accommodation,
  languageId,
  className,
}) => {
  const items = getActionAndContactLinks(
    accommodation,
    actionLinks,
    languageId,
  );

  return !items.length ? null : (
    <div className={ClassNames(styles.HeaderActionLinks, className)}>
      <ul className={styles.HeaderActionLinks__List}>
        {items.map(({ children: content, icon, href, type, title }) => (
          <li key={type}>
            <SmartLink
              isPreview={isPreview}
              anchorAttrs={{
                href,
                className: styles.HeaderActionLinks__LinkItem,
              }}
            >
              <Icon glyph={icon} className={styles.HeaderActionLinks__Icon} />
              <span>{type === "email" ? title : content}</span>
            </SmartLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HeaderActionLinks;
